<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>
              <router-link class="btn btn-sm" :to="{ name: 'AccountList' }">
                <i class="fas fa-chevron-left"></i>
              </router-link>
              Account
            </h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Account</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card" id="Account">
          <div class="overlay" v-if="is_loading">
            <img src="/assets/images/loader.svg" alt="" />
          </div>
          <form @submit.prevent="handleSubmission()" method="POST" novalidate>
            <div class="card-header py-3">
              <h3 class="card-title" v-if="!is_edit">Create</h3>
              <h3 class="card-title" v-if="is_edit">Edit</h3>
            </div>
            <div class="card-body pb-1">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group required" v-if="$organizationId == 1">
                    <label class="control-label">Audra Name</label>

                    <multiselect
                      v-model="value.id"
                      :options="Object.keys(pre.audraName)"
                      :custom-label="opt => pre.audraName[opt]"
                      placeholder="Select Audra Name"
                      :searchable="true"
                      :multiple="false"
                      id="accountId"
                      v-bind:class="{ 'has-error': errors.has('accountId') }"
                      v-validate="'required'"
                      name="accountId"
                    >
                    </multiselect>
                    <div
                      class="help text-danger"
                      v-show="errors.has('accountId')"
                    >
                      {{ errors.first('accountId') }}
                    </div>
                  </div>

                  <div class="form-group required">
                    <label class="control-label">Time Zone</label>

                    <multiselect
                      v-model="value.zone_time"
                      :options="Object.keys(pre.timeZoneList)"
                      :custom-label="opt => pre.timeZoneList[opt]"
                      placeholder="Select Time Zone"
                      :searchable="true"
                      :multiple="false"
                      id="zone_time"
                      v-bind:class="{ 'has-error': errors.has('zone_time') }"
                      v-validate="'required'"
                      name="zone_time"
                    >
                    </multiselect>

                    <div
                      class="help text-danger"
                      v-show="errors.has('zone_time')"
                    >
                      {{ errors.first('zone_time') }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer pb-4 pt-0">
              <button type="submit" v-if="!is_edit" class="btn">Submit</button>
              <button type="submit" v-if="is_edit" class="btn">Update</button>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// import MasterLayout from "@/components/layouts/MasterLayoutComponent";
import { CommonAPI } from '@/services/api'
import LocalStorage from '@/services/localStorage'
import axios from 'axios'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'

export default {
  name: 'AccountForm',
  metaInfo: {
    title: 'Account | Dotlines'
  },
  components: {
    DatePicker
  },
  data: () => ({
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    params: {},

    value: {},
    pre: {
      timeZoneList: [],
      audraName: []
    }
  }),
  methods: {
    handleSubmission () {
      const _this = this
      this.$validator.validateAll().then(result => {
        if (result) {
          _this.is_loading = true
          let api_url = '/accounts'
          let method = 'POST'
          if (_this.is_edit) {
            api_url = '/accounts/' + _this.$route.params.id
            method = 'PUT'
          }

          axios({
            method: method,
            url: api_url,
            data: _this.value,
            headers: { 'Content-Type': 'application/json' }
          })
            .then(function (response) {
              _this.$toaster.success(response.data.message)
              _this.$router.push({ name: 'AccountList' })
            })
            .catch(errors => {
              if (errors.response.status === 500) {
                _this.$toaster.error(errors.response.data.message)
              }
              _this.$setErrorsFromResponse(errors.response.data)
            })
            .finally(() => {
              _this.is_loading = false
            })
        }
      })
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        const api_url = '/accounts/' + id
        axios
          .get(api_url)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            // console.log("error " + error);
            reject(error)
          })
      })
    },
    async initialize () {
      this.is_loading = true
      this.params = this.$route.params

      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true
      }
      if (this.is_edit) {
        await this.getDetail(this.params.id)
          .then(response => {
            this.value = response.data
          })
          .catch(error => {
            console.log(error.response)
          })
      } else {
        this.value.accountId = LocalStorage.get('accountId')
      }

      await CommonAPI.getAudraName(LocalStorage.get('accountId'))
        .then(response => {
          this.pre.audraName = response
        })
        .catch(error => {
          console.log(error.response)
        })
      this.getTimeZone()
      this.is_loading = false
    },
    getTimeZone: function () {
      axios
        .get('get-time-zone', {
          params: {}
        })
        .then(response => {
          this.pre.timeZoneList = response.data
          console.log(response)
        })
        .catch(error => {
          console.log('error ' + error)
        })
        .finally(() => {})
    }
  },
  mounted () {
    this.initialize()
  }
  /* created() {
    this.$emit("update:layout", MasterLayout);
  }, */
}
</script>
